import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { FormInput } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { IRuleParamThenProps } from "./models";

const translationPath = "page.4uBus.integrationRule.integrationRuleParam.";

export const RuleParamThen = memo(
  ({ uBusAutomationParam, busAutomationCode }: IRuleParamThenProps) => {
    const { t } = useTranslation();

    const isAutomationCodeTen = busAutomationCode === 10;

    const thenOneLabel =
      uBusAutomationParam?.code === "1"
        ? t(translationPath + "establishment")
        : uBusAutomationParam?.code === "2"
          ? t(translationPath + "insurance")
          : t(translationPath + "sector");
    const thenTwoLabel =
      uBusAutomationParam?.code === "2"
        ? t(translationPath + "category")
        : t(translationPath + "basic_unit");
    const thenThreeLabel = t(translationPath + "complementary_unit");

    if (isAutomationCodeTen) {
      return (
        <Grid
          container
          spacing={2}
          sx={(t) => ({
            mt: 5,
            pr: 3,
            pl: 1,
            py: 3,
            border: `1px solid ${t.palette.divider}`,
            borderRadius: 2,
          })}
        >
          <Grid item sm={12}>
            <Typography fontWeight="bold">
              {t(translationPath + "then")}
            </Typography>
          </Grid>

          <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
            <Grid item xs={3} textAlign="end" alignSelf="center">
              <Typography fontWeight="bold">
                {t(translationPath + "service_code")}
              </Typography>
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="thenOneName"
                fullWidth
                label={t(translationPath + "destination_name")}
              />
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="thenOneCode"
                fullWidth
                label={t(translationPath + "destination_value")}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    }

    return (
      <Grid
        container
        spacing={2}
        sx={(t) => ({
          mt: 5,
          pr: 3,
          pl: 1,
          py: 3,
          border: `1px solid ${t.palette.divider}`,
          borderRadius: 2,
        })}
      >
        <Grid item sm={12}>
          <Typography fontWeight="bold">
            {t(translationPath + "then")}
          </Typography>
        </Grid>

        <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
          <Grid item xs={3} textAlign="end" alignSelf="center">
            <Typography fontWeight="bold">{thenOneLabel}</Typography>
          </Grid>

          <Grid item xs={4.5}>
            <FormInput
              size="small"
              name="thenOneName"
              fullWidth
              label={t(translationPath + "destination_name")}
            />
          </Grid>

          <Grid item xs={4.5}>
            <FormInput
              size="small"
              name="thenOneCode"
              fullWidth
              label={t(translationPath + "destination_value")}
            />
          </Grid>
        </Grid>

        {uBusAutomationParam?.code !== "1" && (
          <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
            <Grid item xs={3} textAlign="end" alignSelf="center">
              <Typography fontWeight="bold">{thenTwoLabel}</Typography>
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="thenTwoName"
                fullWidth
                label={t(translationPath + "destination_name")}
              />
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="thenTwoCode"
                fullWidth
                label={t(translationPath + "destination_value")}
              />
            </Grid>
          </Grid>
        )}

        {uBusAutomationParam?.code === "3" && (
          <Grid item display="flex" flexDirection="row" xs={12} gap={2}>
            <Grid item xs={3} textAlign="end" alignSelf="center">
              <Typography fontWeight="bold">{thenThreeLabel}</Typography>
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="thenThreeName"
                fullWidth
                label={t(translationPath + "destination_name")}
              />
            </Grid>

            <Grid item xs={4.5}>
              <FormInput
                size="small"
                name="thenThreeCode"
                fullWidth
                label={t(translationPath + "destination_value")}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  },
);
